import Errors from './Errors'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found!');
}

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    getData() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }


    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url, data) {
        return this.submit('post', url, data);
    }

    /**
     * Send a POST request with files to the given URL.
     * .
     * @param {string} url
     */
    postWithFile(url, data) {
        return this.submit('post', url, data, true);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }

    /**
     * Send a PATCH request with files to the given URL.
     * .
     * @param {string} url
     */
    patchWithFile(url, data) {
        return this.submit('patch', url, data, true);
    }

    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url, data, hasFiles = false) {
        let requestMethod = requestType
        let _headers = {}
        let _data = isEmpty(data) ? this.getData() : data
        let formData = new FormData()

        // console.log(_data);

        _.forEach(_data, (value, key) => {
            // console.log(`Key: ${key}`)

            // console.log(`Constructor: ${value?.constructor?.name}`)

            if (value !== null && value.constructor.name == 'FileList' && value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    formData.append(`${key}[]`, value[i])
                }
            } else if (value !== null && value.constructor.name == 'Object') {
                _.forEach(value, (subValue, subKey) => {
                    // console.log(`Sub Key: ${subKey}`)
                    // console.log(`Subvalue Constructor: ${subValue.constructor.name}`)

                    subValue = _.isObject(subValue) ? JSON.stringify(subValue) : subValue

                    formData.append(`${subKey}:${key}`, subValue)
                })
            } else {
                // console.log('Just appending')

                formData.append(key, value)
            }
        })

        if (hasFiles === true) {
            if (requestType == 'patch') {
                requestMethod = 'post'
                formData.append('_method', 'patch')
            }

            _headers = { headers: { 'Content-Type': 'multipart/form-data' } }
        }

        let finalFormData = {}

        for (let entry of formData.entries()) {
            finalFormData[entry[0]] = entry[1]
        }

        return new Promise((resolve, reject) => {
            axios[requestMethod](url, finalFormData /*formData*/, _headers)
                .then(response => {
                    this.onSuccess(response.data, requestType);

                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.onFail(error.response.data);

                    reject(error.response.data);
                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data, requestType) {
        // console.log('ON SUCCESS')
        // console.log(data)

        if (requestType === 'post') {
            this.reset();
        }
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}

export default Form
